import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useCentral} from '../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../models'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../util/functions'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {ConfigDocumentModelDTO} from '../../../model/configDocument.model'
import {configDocumentSchema} from '../../../schema/configDocument'
import {
  createDocsConfig,
  deleteDocsConfig,
  updateDocsConfig,
} from '../../../services/configDocument.service'
import {funcDelete} from '../../../util/function'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
const ConfigDocumentPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)

  const methods = useForm<ConfigDocumentModelDTO>({
    defaultValues: {
      ActivaExpresion: false,
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      ValorBase: '',
      Expresion: '',
    },
    resolver: yupResolver(configDocumentSchema),
  })
  const {reset} = methods

  const handleDelete = async () => {
    await funcDelete(
      deleteDocsConfig,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: ConfigDocumentModelDTO) => {
    try {
      setLoading(true)
      const obj: any = {
        ...data,
        ValorBase: data.ActivaExpresion ? '' : data.ValorBase,
        Direccion: data.ActivaExpresion ? '' : data.Direccion,
        TipoDato: data.ActivaExpresion ? '' : data.TipoDato,
        Expresion: data.ActivaExpresion ? data.Expresion : '',
      }
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await createDocsConfig(obj)
        : await updateDocsConfig({...obj, Id: currentTabItem.idToEdit as any})
      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-config-document',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.messageSystem ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-config-document'
          textComponentGo='form-config-document'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default ConfigDocumentPageWrapper
